export default "__VITE_ASSET__DNxV4BQb__"